import { Bank, Gender, Klant, NederlandsAdres } from '@ha/domain';

export class KlantBuilder {
    private bank: Bank;
    private familienaam: string;
    private tussenvoegsel?: string;
    private voornamen: string;
    private voorletters: string;
    private geboorteDatum: string;
    private geslacht: Gender;
    private emailadres: string;
    private telefoonnummer: string;
    private nederlandsAdres: NederlandsAdres;

    withBank(bank: Bank) {
        this.bank = bank;
        return this;
    }

    withFamilienaam(familienaam: string) {
        this.familienaam = familienaam;
        return this;
    }

    withTussenvoegsel(tussenvoegsel: string) {
        this.tussenvoegsel = tussenvoegsel;
        return this;
    }

    withVoornamen(voornamen: string) {
        this.voornamen = voornamen;
        return this;
    }

    withVoorletters(voorletters: string) {
        this.voorletters = voorletters;
        return this;
    }

    withGeboorteDatum(geboorteDatum: string) {
        this.geboorteDatum = geboorteDatum;
        return this;
    }

    withGeslacht(geslacht: Gender) {
        this.geslacht = geslacht;
        return this;
    }

    withEmailadres(emailadres: string) {
        this.emailadres = emailadres;
        return this;
    }

    withTelefoonnummer(telefoonnummer: string) {
        this.telefoonnummer = telefoonnummer;
        return this;
    }

    withAdres(adres: NederlandsAdres) {
        this.nederlandsAdres = adres;
        return this;
    }

    build(): Klant {
        return {
            bank: this.bank,
            familienaam: this.familienaam,
            tussenvoegsel: this.tussenvoegsel,
            voornamen: this.voornamen,
            voorletters: this.voorletters,
            geboorte_datum: this.geboorteDatum,
            geslacht: this.geslacht,
            emailadres: this.emailadres,
            telefoonnummer: this.telefoonnummer,
            nederlands_adres: this.nederlandsAdres
        } as Klant;
    }
}
